<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.9194 16.2256L14.7514 12.4233C14.9969 12.1797 14.9969 11.8202 14.7514 11.5766L7.34554 4.22795C6.88343 3.76941 6 4.04736 6 4.6513L6 11.1918L10.9194 16.2256Z" fill="#FFE86E" style="fill:#FFE86E;fill:color(display-p3 1.0000 0.9092 0.4324);fill-opacity:1;" />
    <path opacity="0.5" d="M6 12.8077L6 19.3482C6 19.9521 6.88343 20.2301 7.34554 19.7715L10.1175 17.021L6 12.8077Z" fill="#FFE86E" style="fill:#FFE86E;fill:color(display-p3 1.0000 0.9092 0.4324);fill-opacity:1;" />
  </svg>
</template>
